import React from "react";
import LegalDocs from "@/pages/LegalDocs";
export default function Certificates() { return <LegalDocs docClass="certificate" />; }
